import { FieldConfig } from "../../../SetupFormGenerator/types";
import { DEFAULT_PAYMENT_SETTINGS_FIELDS } from "../DEFAULT/constants";

export enum TaxableBenefits {
  CAR = "Car",
  EDUCATION = "Education",
  GROCERY = "Grocery",
  MEDICAL_INSURANCE = "Medical insurance",
  MOVING = "Moving",
  LOANS = "Loans",
  MEAL_ALLOWANCE = "Meal allowance",
  REMOTE_WORK = "Remote work",
}

export const TAXABLEBENFITSVALUES = Object.values(TaxableBenefits);
export const TaxableBenefitsTypeMessage = null;

export const PAYMENT_SETTINGS_FIELDS: FieldConfig[] =
  DEFAULT_PAYMENT_SETTINGS_FIELDS;
